import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=7b9b6120&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=7b9b6120&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b6120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9b6120')) {
      api.createRecord('7b9b6120', component.options)
    } else {
      api.reload('7b9b6120', component.options)
    }
    module.hot.accept("./productDetail.vue?vue&type=template&id=7b9b6120&scoped=true", function () {
      api.rerender('7b9b6120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/productDetail.vue"
export default component.exports